<template>
  <section>
    <div class="row">
      <div class="col-md-12">
        <p>This facility is used by ADAS MAP super administrators to configure the calibration services, system types, etc.</p>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-6">
        <!-- Systems -->
        <span class="custom-title">Systems:</span>
        <input v-model="systemInactive" type="checkbox" class="custom-checkbox ms-3 me-2" />
        <span>show inactive</span>
        <div v-if="isEditSystem" class="custom-setinactive">
          <input v-model="setSystemInactive" type="checkbox" class="custom-checkbox ms-3 me-2" @click="changedInactive('System')" />
          <span>set inactive</span>
        </div>
        <div class="input-group mb-3 mt-2">
          <input
            v-show="(isEditSystem || isAddSystem) && !viewingInactive"
            ref="refEditSystem"
            v-model="modifySystem"
            type="text"
            class="form-control"
            placeholder="new System"
            aria-label="new System"
          />
          <select
            v-show="!isEditSystem && !isAddSystem"
            ref="refSelectSystem"
            v-model="currentSystem"
            class="form-control custom-select"
            @change="selectedSystem"
          >
            <option v-for="item of systems" :key="item.id" :value="item.value">
              {{ item.name }}
            </option>
          </select>
          <span class="input-group-text">CCC Item</span>
          <select v-model="cccItemType" class="form-control custom-select" title="CCC Item" placeholder="CCC Item">
            <option v-for="item of cccItemTypes" :key="item.id" :value="item.value">
              {{ item.name }}
            </option>
          </select>
          <button
            v-if="isSelectedSystem && !isEditSystem && !isAddSystem && !viewingInactive"
            class="btn btn-warning custom-focus"
            type="button"
            title="edit system"
            tabindex="-1"
            @click="editSystem"
          >
            <i class="far fa-edit"></i>
          </button>
          <button
            v-if="isSelectedSystem && !isEditSystem && !isAddSystem && !viewingInactive"
            class="btn btn-danger custom-focus"
            type="button"
            title="set inactive"
            tabindex="-1"
            @click="removeSystem"
          >
            <i class="far fa-trash-alt"></i>
          </button>
          <button
            v-if="isEditSystem || isAddSystem"
            class="btn btn-warning custom-focus"
            type="button"
            title="edit system"
            tabindex="-1"
            @click="cancel"
          >
            <i class="fas fa-ban"></i>
          </button>
          <button
            v-if="!isEditSystem && !isAddSystem"
            class="btn btn-success custom-focus"
            type="button"
            title="add system"
            tabindex="-1"
            @click="addSystem"
          >
            <i class="fas fa-plus"></i>
          </button>
          <button v-if="isSave && workingOn === 'System'" class="btn btn-primary custom-focus" type="button" tabindex="-1" @click="saveSystem">
            Save
          </button>
        </div>
        <div class="row">
          <!-- System Calibrations -->
          <div v-if="isSelectedSystem" class="input-group mb-3">
            <span class="input-group-text">Add Calibration</span>
            <select
              v-model="calibrationType"
              class="form-control custom-select"
              title="Calibration Service"
              placeholder="Calibration Service"
              @change="changedCalibration"
            >
              <option v-for="item of lookups['CalibrationType']" :key="item.id" :value="item.value">
                {{ item.name }}
              </option>
            </select>
            <button v-if="isCalibrationChanged" class="btn btn-primary custom-focus" type="button" tabindex="-1" @click="saveCalibration">
              <i class="fas fa-plus"></i>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <ul class="custom-list">
              <li v-for="item in calibrationsOfSystem" :key="item.id">
                <span>{{ item.name }}</span>
                <div class="custom-trash" @click="removeCalibration(item.id)"><i class="far fa-trash-alt"></i></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <confirm
      v-model="actionDelete"
      :confirm-title="confirmTitle"
      :confirm-action="confirmAction"
      :confirm-question="confirmQuestion"
      @closing="closeModal"
      @proceed="performDelete"
    />
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { lookupStore } from '@/stores/lookup'
import { dataStore } from '@/stores/data'
import _ from 'lodash'
import Confirm from '@/components/utilities/elements/ConfirmDialog.vue'
export default {
  name: 'AdminConfigGeneral',
  components: {
    Confirm
  },
  data() {
    return {
      isEditSystem: false,
      isAddSystem: false,
      modifySystem: null,
      currentSystem: null,
      chkInactiveSystem: false,
      isSelectedSystem: false,
      confirmTitle: 'Remove?',
      confirmAction: 'Remove',
      confirmQuestion: 'Are you sure you wish to Remove (set inactive) this item?',
      actionDelete: null,
      isSave: false,
      inactiveChanged: false,
      setSystemInactive: false,
      calibrationType: null,
      cccItemType: null,
      isCalibrationChanged: false,
      systemCalibration: null
    }
  },
  mounted() {
    this.inactiveChanged = false
    this.setSystemInactive = false
    this.cancel()
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(lookupStore, ['lookups']),
    ...mapState(dataStore, ['loading', 'systemCalibrations']),
    systems() {
      let cnt = 1
      let _data = []
      if (this.lookups) {
        if (this.lookups['SystemType']) {
          let types = JSON.parse(JSON.stringify(this.lookups['SystemType']))
          _data = _.sortBy(types, ['name'])
          _data.forEach((element) => {
            element.id = cnt
            cnt++
          })
        }
      }
      return _data
    },
    cccItemTypes() {
      let cnt = 1
      let _data = []
      if (this.lookups) {
        if (this.lookups['CCCItemType']) {
          let types = JSON.parse(JSON.stringify(this.lookups['CCCItemType']))
          _data = _.sortBy(types, ['name'])
          _data.forEach((element) => {
            element.id = cnt
            cnt++
          })
          _data.unshift({
            id: 0,
            name: '',
            value: null
          })
        }
      }
      return _data
    },
    calibrationsOfSystem() {
      let _items = []
      console.log('Calibrations of System', this.lookups['CalibrationType'])
      if (this.lookups['CalibrationType']) {
        let ids = this.systemCalibrations.map((x) => parseInt(x.id))
        _items = this.lookups['CalibrationType'].filter((x) => ids.includes(x.id))
      }
      return _items
    },
    workingOn() {
      let _on = null
      if (this.isEditSystem || this.isAddSystem) {
        _on = 'System'
      }
      return _on
    },
    systemInactive: {
      get() {
        return this.chkInactiveSystem
      },
      set(value) {
        this.chkInactiveSystem = value
        this.reload('SystemType')
      }
    },
    viewingInactive() {
      let _is = false
      if (this.chkInactiveSystem) {
        _is = true
      }
      return _is
    }
  },
  methods: {
    ...mapActions(lookupStore, ['getLookups', 'upsertLookup']),
    ...mapActions(dataStore, ['deleteCalibration', 'resetCalibrations', 'getSystemCalibrations']),
    closeModal() {
      this.actionDelete = null
    },
    async reload(what) {
      await this.getLookups({
        keys: [what],
        firm: 1,
        refresh: true,
        showInactive: what === 'SystemType' ? this.chkInactiveSystem : false
      })
      this.cccItemType = null
      this.currentSystem = null
      this.currentLocation = null
      this.resetCalibrations()
      this.cancel()
    },
    async selectedSystem() {
      this.isSelectedSystem = true
      this.systemCalibration = null
      this.isCalibrationChanged = false
      this.inactiveChanged = false
      this.setSystemInactive = false
      this.cccItemType = null
      this.calibrationType = null
      if (this.currentSystem) {
        let found = this.systems.find((x) => parseInt(x.value) === parseInt(this.currentSystem))
        this.systemCalibration = JSON.parse(JSON.stringify(found))
        this.cccItemType = this.systemCalibration.type2 ? parseInt(this.systemCalibration.type2) : null
        await this.getSystemCalibrations(this.systemCalibration.value)
      }
      let cccItemType = this.lookups['CCCItemType'].find((x) => parseInt(x.id) === parseInt(this.systemCalibration.type2))
      console.log('Selected System', {
        systemCalibration: this.systemCalibration,
        cccItemType: cccItemType
      })
    },
    cancel() {
      this.modifySystem = null
      this.inactiveChanged = false
      this.setSystemInactive = false
      this.isSave = false
      setTimeout(() => {
        if (this.workingOn === 'System') {
          this.$refs.refSelectSystem.focus()
        }
      }, 250)
      this.isEditSystem = false
      this.isAddSystem = false
    },
    async changedCalibrationPricing(value) {
      this.resetPrices()
      this.calibrationTypeForPricing = parseInt(value)
      await this.getCalibrationPricing(value)
    },
    async changedCalibration() {
      this.isCalibrationChanged = true
      console.log('Selected Calibration', {
        systemCalibration: this.systemCalibration,
        calibrationType: this.calibrationType
      })
    },
    changedInactive(what) {
      if (what === 'System') {
        this.inactiveChanged = true
      }
    },
    async addSystem() {
      if (this.chkInactiveSystem) {
        let found = this.systems.find((x) => parseInt(x.value) === parseInt(this.currentSystem))
        if (found) {
          // save
          let data = {
            firm: 1,
            id: parseInt(found.value),
            key: 'SystemType',
            name: found.name.trim(),
            type1: null,
            type2: null,
            isInactive: false
          }
          await this.upsertLookup(data)
          await this.reload('SystemType')
        }
      } else {
        this.cccItemType = null
        this.isEditSystem = false
        this.isAddSystem = true
        this.modifySystem = null
        this.isSelectedSystem = false
        this.isSave = true
        setTimeout(() => {
          this.$refs.refEditSystem.focus()
        }, 250)
      }
    },
    editSystem() {
      this.isEditSystem = false
      this.isAddSystem = false
      this.isSave = false
      this.modifySystem = null
      let found = this.systems.find((x) => parseInt(x.value) === parseInt(this.currentSystem))
      if (found) {
        this.modifySystem = found.name.trim()
        this.isEditSystem = true
        this.isSave = true
        setTimeout(() => {
          this.$refs.refEditSystem.focus()
        }, 250)
      }
    },
    async saveSystem() {
      let valid = true
      let found = null
      let reason = 'Please supply a system name'
      if (this.modifySystem === null) {
        valid = false
      } else if (this.modifySystem.trim() === '') {
        valid = false
      } else {
        found = this.systems.find((x) => x.name.trim() === this.modifySystem.trim())
        if (found && !this.isEditSystem) {
          valid = false
          reason = 'System already exists'
        }
      }
      if (valid) {
        let data = {
          firm: 1,
          id: null,
          key: 'SystemType',
          name: this.modifySystem.trim(),
          type1: null,
          type2: this.cccItemType ? parseInt(this.cccItemType) : null,
          isInactive: false
        }
        if (this.isEditSystem) {
          let found = this.systems.find((x) => parseInt(x.value) === parseInt(this.currentSystem))
          if (found) {
            // save
            data = {
              firm: 1,
              id: parseInt(found.value),
              key: 'SystemType',
              name: this.modifySystem.trim(),
              type1: found.type1,
              type2: this.cccItemType ? parseInt(this.cccItemType) : null,
              isInactive: this.setSystemInactive
            }
          }
        }
        await this.upsertLookup(data)
        this.isEditSystem = false
        this.isAddSystem = false
        this.isSave = false
        this.modifySystem = null
        this.cccItemType = null
        await this.reload('SystemType')
      } else {
        alert(reason)
      }
    },
    removeSystem() {
      this.confirmTitle = 'Remove System?'
      this.confirmQuestion = 'Are you sure you wish to Remove (set inactive) this System?'
      this.actionDelete = {
        name: 'System'
      }
    },
    removeCalibration(id) {
      this.confirmTitle = 'Remove Calibration?'
      this.confirmQuestion = 'Are you sure you wish to Remove this Calibration?'
      this.actionDelete = {
        name: 'Calibration',
        calibrationType: id
      }
    },
    async performDelete() {
      let found = null
      let data = null
      if (this.actionDelete.name === 'Calibration') {
        console.log('Removing Calibration', this.currentSystem)
        await this.deleteCalibration({
          systemType: this.currentSystem,
          calibrationType: this.actionDelete.calibrationType
        })
        this.selectedSystem()
      } else if (this.actionDelete.name === 'System') {
        console.log('Removing System', this.currentSystem)
        found = this.systems.find((x) => parseInt(x.value) === parseInt(this.currentSystem))
        if (found) {
          // remove
          data = {
            firm: 1,
            id: parseInt(found.value),
            key: 'SystemType',
            name: found.name.trim(),
            type1: null,
            type2: null,
            isInactive: true
          }
          await this.upsertLookup(data)
          await this.reload('SystemType')
          this.cccItemType = null
          this.isSelectedSystem = false
        }
      }
      this.actionDelete = null
    },
    async saveCalibration() {
      console.log('Save Calibration', this.systemCalibration)
      this.systemCalibration.type1 = this.calibrationType ? parseInt(this.calibrationType) : null
      this.systemCalibration.type2 = this.cccItemType ? parseInt(this.cccItemType) : null
      let data = {
        firm: 1,
        id: parseInt(this.systemCalibration.value),
        key: 'SystemType',
        name: this.systemCalibration.name.trim(),
        isInactive: false,
        type1: this.systemCalibration.type1,
        type2: this.systemCalibration.type2
      }
      await this.upsertLookup(data)
      this.isCalibrationChanged = false
      await this.reload('SystemType')
      this.currentSystem = parseInt(this.systemCalibration.value)
      this.selectedSystem()
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-setinactive {
  display: inline-block;
  float: right;
  margin-right: 25px;
}
.custom-focus:focus {
  border-color: inherit;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none;
  border: transparent;
}
.custom-title {
  font-weight: bold;
}
.custom-calibration {
  width: 50%;
}
.custom-list {
  list-style-type: none;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 400px;
  li {
    padding: 5px;
  }
}
.custom-trash {
  float: right;
  cursor: pointer;
  color: rgb(122, 0, 0);
}
</style>
